export default defineNuxtRouteMiddleware(async () => {
  try {
    if (import.meta.server) {
      const nuxtApp = useNuxtApp();
      const req = useRequestHeaders();
      const locale = req['x-locale'];

      if (locale) {
        await nuxtApp.$i18n.setLocale(locale);
      }
    }

    if (import.meta.client) {
      const nuxtApp = useNuxtApp();
      const locales = useRuntimeConfig().public.i18n.locales;

      for (const locale of Object.keys(locales)) {
        if (locales[locale].domain === window.location.hostname) {
          await nuxtApp.$i18n.setLocale(locale);
        }
      }
    }
  } catch (error) {
    console.error("Error in middleware:", error);
  }
})
